<script>
    export let data;

    import {Button} from "carbon-components-svelte";
    import TaskAdd20 from "carbon-icons-svelte/lib/TaskAdd20";
    import EnumStatus from "../services/taskstatus";
    import {updateTask} from "../store";

    function updateTaskDo() {
        data.status = EnumStatus.ASAP;
        data = data;
        updateTask(data)
    }

    
</script>

<Button kind="ghost" aria-label="Do" iconDescription="Do" on:click={updateTaskDo} icon={TaskAdd20}
></Button
>

<!-- <style>
Button {
    text-align: center;
    padding: 0em;
    max-width: 240px;
    margin: 0 auto;
}
</style> -->